export default {
  ft: {to_meter: 0.3048},
  'us-ft': {to_meter: 1200 / 3937}
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/proj4/lib/constants/units.js
// module id = 257
// module chunks = 0